import styled from 'styled-components';
import { FONT_COLORS } from 'variables/theme';
import { FONT_SETS } from 'variables/typography';

export const MenuLabel = styled.p`
  ${FONT_SETS.description};
  text-transform: none;
  color: ${FONT_COLORS.gray};
`;
